var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"condition-content"},[_c('compare-selector',{ref:"selector",attrs:{"value":_vm.currentValue,"valid":_vm.valid,"multiple":true,"type":"AGE","placeholder":"请选择年龄段"},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }